
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyDcdGFyq_7KjQHLlMsatX7wzWE0DPpr-cA",
  authDomain: "firechat-e261e.firebaseapp.com",
  projectId: "firechat-e261e",
  storageBucket: "firechat-e261e.appspot.com",
  messagingSenderId: "128278661422",
  appId: "1:128278661422:web:b03dcbfeac9c3e244452bf",
  measurementId: "G-B7ZG11X793"
})
// can access database and auth

const db = firebaseApp.firestore()

const auth = firebase.auth()

export {db, auth};